module.exports = __webpack_public_path__ + "assets/2e239cb0613b4ae595dc0bcf863cbf79.mp3";